require('./css/main.css');
require('./assets/mobirise/style.css');
require('./assets/mobirise/fonts/mobirise.ttf');

import Vue from 'vue'
import App from './App'
const Home = () => import('@/components/Home.vue')
import VueRouter from 'vue-router'
import VueScrollReveal from 'vue-scroll-reveal'
import AOS from 'aos'
import 'aos/dist/aos.css'

Vue.use(VueScrollReveal)

Vue.use(VueRouter);

const routes = [
    {
      path: '/',
      name: 'Home',
      component: Home
    }
  ]

const router = new VueRouter({
mode: 'history',
routes,
scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
    }
});

Vue.config.productionTip = false


new Vue({
  el: '#app',
  router,
  created () {
    AOS.init()
  },
  render: h => h(App)
});
